site.dropdownMenu = {
	init: function () {
		site.dropdownMenu.sidebarMenu();
	},
	sidebarMenu: function() {
		var $sidebarMenu = $('#sidebar');
		$('.children', $sidebarMenu).prepend('<span class="expand"></span>');
		$('.selectedLevel2', $sidebarMenu).addClass('down');
		$('.selectedLevel3', $sidebarMenu).addClass('down');
		$('.selectedLevel4', $sidebarMenu).addClass('down');
		$('.expand', $sidebarMenu).bind('click', function(e) {
			e.preventDefault();
			$(this).closest('li').toggleClass('down');
		});
	}
};
site.inits.push('site.dropdownMenu.init()');
